'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import Composer from '@/common/Composer';
import SuggestedFilterChips from '@/common/SuggestedFilterChips';
import FilterMenuChip from '@/srp/FilterMenuChip';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import { useInventoryIsLoaded } from '~/context/srp/InventoryContext';
import useSuggestedFilterChipItems from '~/hooks/srp/useSuggestedFilterChipItems';
import ComposerFilterLoadingIndicator from './ComposerFilterLoadingIndicator';

export default function SrpComposerUi() {
  const showComposerTreatment = useShowComposerTreatment();
  const trackEvent = useTrackEvent();
  const isApplyingFilters = !useInventoryIsLoaded();
  const { isLoading, items, showCounts, showSuggestedFilters } =
    useSuggestedFilterChipItems();
  const hasSuggestedFilterChips =
    showSuggestedFilters && (isLoading || items.length > 0);

  useEffectOnce(
    () => {
      trackEvent('composer_shell_loaded', {
        chipsOffered: items.map(item => item.label),
        page: 'srp'
      });
    },
    [items, trackEvent],
    showComposerTreatment && !isLoading
  );

  if (!showComposerTreatment) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40">
      <Composer
        inputPlaceholder="Search or ask me anything"
        page="srp"
        slot={
          isApplyingFilters ? (
            <div aria-live="polite" role="status">
              <ComposerFilterLoadingIndicator />
            </div>
          ) : hasSuggestedFilterChips ? (
            <>
              <FilterMenuChip
                dataAdobeId="composer-filter-menu"
                dataAnalyticsAttributes={JSON.stringify({
                  item: 'open modal button',
                  source: 'composer'
                })}
                shape="pill"
                source="composer"
                testId="composer-open-filter-modal"
              />
              <SuggestedFilterChips
                isLoading={isLoading}
                items={items}
                shape="pill"
                showCounts={showCounts}
              />
            </>
          ) : undefined
        }
        slotEdgesVisible
      />
    </div>
  );
}
